/**
 * Волна E (docs/MIGRATION_ROUTER.md §5).
 * Было: <CacheDataRoute exact path='/bar-menu/:barId/:tableId/categories' withoutFooter withoutHeader>.
 * path в staticData — для consent-модалки Header (includes('/bar-menu/')).
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../../../CacheDataRoute';
import BarMenuCategories from '@routes/BarMenu/stages/BarMenuCategories';

export const Route = createFileRoute('/bar-menu/$barId/$tableId/categories/')({
  staticData: {
    layout: {
      path: '/bar-menu/:barId/:tableId/categories',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute component={BarMenuCategories} path='/bar-menu/:barId/:tableId/categories' />
  )
});
